var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlineSupporting = function SvgOnlineSupporting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "transparent",
    d: "M16.557 7.395a13.05 13.05 0 0 1 18.01 11.155H30.85a4 4 0 0 0-4 4v4.65a4 4 0 0 0 4 3.999h1.55a4 4 0 0 0 2.194-.655 5.3 5.3 0 0 1-5.294 5.054H21.55a.9.9 0 0 0 0 1.8h7.75a7.1 7.1 0 0 0 7.099-7.1V19.45a14.848 14.848 0 1 0-29.697 0v7.75a4 4 0 0 0 4 3.999h1.55a4 4 0 0 0 3.999-4v-4.65a4 4 0 0 0-4-3.999H8.533a13.05 13.05 0 0 1 8.024-11.155Zm18.042 19.792V20.35h-3.75a2.2 2.2 0 0 0-2.2 2.2v4.65a2.2 2.2 0 0 0 2.2 2.199h1.55a2.2 2.2 0 0 0 2.2-2.18v-.032ZM8.502 27.2V20.35h3.75a2.2 2.2 0 0 1 2.199 2.2v4.65a2.2 2.2 0 0 1-2.2 2.199h-1.55a2.2 2.2 0 0 1-2.199-2.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgOnlineSupporting;